/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import CartItem from './cartitem';

var accounting = require('accounting');
var tr = require('ts-translate-js').default.boundTR;
var trN = tr;
var modal = require('../modal');
import createClass from 'create-react-class';
import { SiteCustomizationContext } from '../../src/logic/reactcontext/site-customization-context';
import { trackUserAction } from '../../js/client-tracking';
var _utilctl = require('../utilctl');
var tsRest = require('ts-rest-client');

var PRODUCT_TYPE = {
    Ticket: 0,
    PrepaidCard: 1,
    MembershipCard: 2,
    Product: 3,
    Donation: 4
};

export const CartContent = createClass({
    displayName: "CartContent",

    propTypes: {
        cart: PropTypes.object,
        readOnly: PropTypes.bool,
        emphasisOnUncompletedThings: PropTypes.bool,
        onContentChange: PropTypes.func,
        onModifySaleQuestionnaire: PropTypes.func
    },

    getDefaultProps: function () {
        return { emphasisOnUncompletedThings: false,  };
    },

    getInitialState: function () {
        return { errorOnAction:"" };
    },

    componentDidMount(){
        this.modalContainerRef = React.createRef();
        this.raiseContentChanged();
    },

    componentDidUpdate(){
        this.raiseContentChanged();
    },

    componentWillUnmount: function () {
        if(this.removeItemRequest != null) this.removeItemRequest.abort();
        if(this.removeTicketRequest != null) this.removeTicketRequest.abort();
        if(this.upDelivRequest != null) this.upDelivRequest.abort();
    },

    raiseContentChanged() {
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(this.props.onContentChange !== undefined) this.props.onContentChange();
        }.bind(this), 0);
    },


    reloadCart(){
        this.props.onUpdateCart();
    },

    handleRemoveItem(id, force = false){
        this.removeItemRequest = tsapp.mvcapi.postCtl("cart/removeitem", {itemID:id, forceRemove: force})
                                      .success(function(data){
                                          this.reloadCart()
                                      }.bind(this))
                                      .notSuccess(function(data){
                                        var idTried = id;
                                        if (data.message == "CART_IS_EMPTY")
                                            this.setState({errorOnAction: "CART_IS_EMPTY"})
                                        else
                                            this.setState({
                                                itemRemoveResult: data,
                                                executeForceDelete: function() { this.handleRemoveItem(idTried, true)  }.bind(this)})
                                      }.bind(this));
    },

    handleRemoveTicket(id, force = false){
        this.removeTicketRequest = tsapp.mvcapi.postCtl("cart/removeticket", {ticketID:id, forceRemove: force})
                                        .success(function(data){
                                            this.reloadCart()
                                        }.bind(this))
                                        .notSuccess(function(data){
                                            var idTried = id;
                                            if (data.message == "CART_IS_EMPTY")
                                                this.setState({errorOnAction: "CART_IS_EMPTY"})
                                            else{
                                                this.setState({
                                                    itemRemoveResult: data,
                                                    executeForceDelete: function() { this.handleRemoveTicket(idTried, true)  }.bind(this)
                                                });
                                            }
                                        }.bind(this));
    },

    handleForceRemoveItemOrTicket(){
        this.setState({ itemRemoveResult: null });
        if(this.state.executeForceDelete)
            this.state.executeForceDelete(); // Rerun delete with a force=true
    },

    handleCancelRemove() {
        this.setState({ itemRemoveResult: null });
    },

    handleUpdateDeliveryMethod(id, isMailDelivery, isEticketDelivery, shippingFeeId){
        this.upDelivRequest = tsapp.mvcapi.postCtl("cart/updateshippingonanitem", {itemID:id, isMailDelivery, isEticketDelivery, shippingFeeID: shippingFeeId})
            .success(function(data){
                this.reloadCart()
                
                const method = isMailDelivery ? 'Mail delivery' : (isEticketDelivery ? 'e-ticket delivery' : 'Box office')

                const trackingData = {
                    name: 'deliveryMethodChanged',
                    shippingMethod: method,
                    item: {
                        label: method
                    },
                    urlSource: window.location.href
                };
                trackUserAction(this.props.integ, trackingData);
            }.bind(this))
            .notSuccess(function(data){
                this.setState({errorOnAction:data.message == "CART_IS_EMPTY" ? data.message : ""});
            }.bind(this))
    },
    
    handleOpenSaleQuestionnairesByCart() {
        tsapp.mvcapi.postCtl("cart/getsalequestionnaireresultbycart")
             .success((saleQuestionnaires) =>
                 {
                    if(saleQuestionnaires.IsSuccess) 
                        this.props.onModifySaleQuestionnaire(saleQuestionnaires.result);
                 })
             .notSuccess((saleQuestionnaires) =>
                {
                    if(!saleQuestionnaires.IsSuccess) {
                        alert("Le panier est expiré!");
                        this.props.onReloadCart();
                    }
                });
    },

    render(){
        // This should be elsewhere, that's horrible
        var errorMessages = {
            "CART_IS_EMPTY": tsapp.tr("Votre panier est presentement vide, la page sera actualisee"),
            "PROFILE_IS_EMPTY": tsapp.tr("Aucun profil est connecte, la page sera actualisee")
        };

        var errorOnAction = this.state.errorOnAction != ""
                ? <_utilctl.ErrorOnActionMessage message={this.errorMessages[this.state.errorOnAction]}/>
                : null;

        var cartItems = this.props.cart.Items.map(function(cartItem){
            return (
                <CartItem 
                    key={cartItem.ID}
                    cartItem={cartItem}
                    onRemoveItem={this.handleRemoveItem}
                    onRemoveTicket={this.handleRemoveTicket}
                    onUpdateDeliveryMethod={this.handleUpdateDeliveryMethod} 
                    onContentChange={this.props.onContentChange}
                    readOnly={this.props.readOnly}
                    emphasisOnUncompletedThings={this.props.emphasisOnUncompletedThings}
                    onModifySaleQuestionnaire={this.props.onModifySaleQuestionnaire}
                    onReloadCart={this.reloadCart}
                />
            )}.bind(this))

        // Dependent item removal confirm box ---
        var errorModal;
        var removeResult = this.state.itemRemoveResult;
        if(removeResult && !removeResult.IsSuccess) {
            if(removeResult.productsDependentOfMembership
               && removeResult.productsDependentOfMembership.length > 0) {
                var totalDependantItems = removeResult.productsDependentOfMembership.length; // For if we have other kinds of dependancy later
                var membershipDependantProds = removeResult.productsDependentOfMembership.map(function(depProd) {
                    return <li key={depProd.NameWithEventDate}>{depProd.CartItem.NameWithEventDate}</li>;
                });

                var buttons = [
                    { label: tr("button.cancel"), onClick: this.handleCancelRemove },
                    { label: trN("Retirer aussi ce produit du panier", "Retirer aussi tous ces produits du panier", { n: totalDependantItems }), onClick: this.handleForceRemoveItemOrTicket, kind: "danger" }
                ];

                errorModal = (
                    <modal.Confirm showCloseButton={false} title={tr("cartcontent.itemDependancyPanel.cannotRemoveTitle")} buttons={buttons} container={this.modalContainerRef.current}>
                        <p>{trN("L'item que vous désirez retirer du panier est nécéssaire pour le produit suivant", "L'item que vous désirez retirer est nécéssaire pour les produits suivants", { n: totalDependantItems })}</p>
                        { membershipDependantProds }
                    </modal.Confirm>
                );
            } else {
                errorModal = <modal.ConfirmOK showCloseButton={false} title={tr("cartcontent.itemDependancyPanel.cannotRemoveTitle")} message={removeResult.Message} onOK={function() { this.setState({ itemRemoveResult: null }); }.bind(this)} container={this.modalContainerRef.current}/>;
            }
        }

        // var shippingFee = (siteSettings) => { 
        //     if (this.props.cart.TotalShippingFees > 0) {
        //         <tr className="active">
        //                 <td className="text-right">{tr("cartcontent.shippingfee")}</td>
        //                 <td></td>
        //                 <td className="text-right nowrap">{accounting.formatMoney(this.props.cart.TotalShippingFees)}</td>
        //         </tr>;
        //     }
        // };


        var buttonModifySaleQuestionnaires = (this.props.cart.HasCartSaleQuestionaireDefinition && !this.props.cart.HaveUnfilledQuestionnaireByCart ? 
            <button type="button" className="btn btn-primary btn-xs" onClick={() => this.handleOpenSaleQuestionnairesByCart()}>{tr("Modifier le formulaire du panier")}</button>
        : null);

        return (
            <SiteCustomizationContext.Consumer>
                {({ siteSettings }) => {
                    return <div>
                        {errorOnAction}
                        <table className="table capslock" id="tbldetail">
                            <thead>
                                <tr>
                                    <th>{tsapp.tr("cartcontent.description")}</th>
                                    <th className="col-md-1 text-center">{tsapp.tr("cartcontent.quantity")}</th>
                                    <th className="col-md-1 text-right">{tsapp.tr("cartcontent.price")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cartItems}
                            </tbody>
                            <tfoot>
                                {this.props.cart.TotalShippingFees > 0 &&
                                    <tr className="active">
                                        <td className="text-right">{tr("cartcontent.shippingfee")}</td>
                                        <td></td>
                                        <td className="text-right nowrap">
                                            {siteSettings.taxesOnlyAtCheckout 
                                                ? accounting.formatMoney(this.props.cart.TotalShippingFeesBeforeTaxes)
                                                : accounting.formatMoney(this.props.cart.TotalShippingFees)
                                            }
                                        </td>
                                    </tr>
                                }
                                {
                                    siteSettings.taxesOnlyAtCheckout && <>
                                        <tr className="active text-bold">
                                            <td className="">
                                                <div className="row">
                                                    <div className="col-xs-9 col-md-5">{buttonModifySaleQuestionnaires}</div>
                                                    <div className="col-xs-3 col-md-7 text-right"> {tr("Sous-total :")}</div>
                                                </div>
                                            </td>
                                            <td className="text-center"></td>
                                            <td className="text-right nowrap">{accounting.formatMoney(this.props.cart.TotalBeforeTaxes)}</td>
                                        </tr>
                                        <tr className="text-bold">
                                            <td className="">
                                                <div className="row">
                                                    <div className="col-xs-9 col-md-5">{buttonModifySaleQuestionnaires}</div>
                                                    <div className="col-xs-3 col-md-7 text-right"> {this.props.cart.Tax1Names} :</div>
                                                </div>
                                            </td>
                                            <td className="text-center" />
                                            <td className="text-right nowrap">{accounting.formatMoney(this.props.cart.Taxe1Amount)}</td>
                                        </tr>
                                        <tr className="text-bold">
                                            <td style={{border: "none"}} className="">
                                                <div className="row">
                                                    <div className="col-xs-9 col-md-5">{buttonModifySaleQuestionnaires}</div>
                                                    <div className="col-xs-3 col-md-7 text-right"> {this.props.cart.Tax2Names} :</div>
                                                </div>
                                            </td>
                                            <td style={{border: "none"}} className="text-center" />
                                            <td style={{border: "none"}} className="text-right nowrap">{accounting.formatMoney(this.props.cart.Taxe2Amount)}</td>
                                        </tr>
                                    </>
                                }
                                <tr className="active text-bold">
                                    <td className="">
                                        <div className="row">
                                            <div className="col-xs-9 col-md-5">{buttonModifySaleQuestionnaires}</div>
                                            <div className="col-xs-3 col-md-7 text-right"> {tr("cartcontent.total")}</div>
                                        </div>
                                    </td>
                                    <td className="text-center">{this.props.cart.TotalQuantity}</td>
                                    <td className="text-right nowrap">{accounting.formatMoney(this.props.cart.Total)}</td>
                                </tr>
                            </tfoot>
                        </table>
                        <div ref={this.modalContainerRef} />
                        {errorModal}
                    </div>;
                }}
            </SiteCustomizationContext.Consumer>
            )
        }
    }
);
